<template lang="pug">
.reserve-page
  .main-title
    .person
      .person-fullName
        .firstName Hello {{ $root.member.user_name }}
        .lastName {{ $root.member.name }}
      .person-avatar
        img.user-pic(:src="$root.member.user_picture", alt="alt")
    p 歡迎預約
    
  .sub-title 
    | 請選擇想預約的類型
  .rental-type
    .rental-item(
      v-for="item in $root.carTypes" 
      v-if="item.type == $root.register.itemType"
      @click="selectItem(item.id)" 
      :class="{active: selectCars.indexOf(item.id) > -1}"
    )
      img.rental-item-img(:src="item.img",v-if="item.img")
      .rental-content {{ item.title }}
      .on-select(v-if="selectCars.indexOf(item.id) > -1")
        img(src="../assets/images/check.svg")

  .sub-title(v-if="$root.register.carTypes.length") 
    | 請選擇您的所在地
  select.city-select(v-model="now_select_city",v-if="$root.register.carTypes.length")
    option(value="") 選擇縣市
    option(v-for="op in options" :value="op" :disabled="!$root.hasShop(op)") 
      span {{ op }}
      span(v-if="!$root.hasShop(op)") (未開放)

  .button-group
    button.stepUp(type="button" @click="$router.go(-1)") 
      .step-txt 上一步
    button.stepNext(type="button" @click="goNext" :class="{active: (now_select_city && selectCars.length)}") 
      .step-txt 下一步
</template>

<script>
export default {
  name: "reserve-page",
  components: {},
  data () {
    return {
      now_select_city: "",
      options: [
        "全部",
        "臺北市",
        "新北市",
        "基隆市",
        "桃園市",
        "臺中市",
        "臺南市",
        "高雄市",
        "新竹縣",
        "苗栗縣",
        "彰化縣",
        "南投縣",
        "雲林縣",
        "嘉義縣",
        "屏東縣",
        "宜蘭縣",
        "花蓮縣",
        "臺東縣",
        "澎湖縣",
        "金門縣",
        "連江縣",
        "新竹市",
        "嘉義市",
      ],
      selectCars: []
    };
  },
  methods: {
    selectItem (_id) {
      console.log('--> 選擇項目ID:', _id)

      if (this.selectCars.indexOf(_id) > -1) {
        var index = this.selectCars.indexOf(_id)
        if (index !== -1) {
          this.selectCars.splice(index, 1);
        }
        return
      }

      this.selectCars.push(_id)

      this.changeOrder()
    },
    async changeOrder () {
      let vm = this
      if (this.selectCars) {
        let carTypes = []
        await this.selectCars.forEach(function (_rowId) {
          let searchCarType
          vm.$root.carTypes.forEach(function (_row) {
            if (_row.id === _rowId) {
              searchCarType = _row
            }
          })
          carTypes.push({
            id: searchCarType.id,
            typeId: _rowId,
            title: searchCarType.title,
            amount: 0
          })
        })

        // 將車輛型態放入清單
        this.$root.register.carTypes = await carTypes
        console.log('$root.register:', this.$root.register)
      }
    },
    goNext () {
      let vm = this
      this.$root.selectCity = this.now_select_city
      if (this.now_select_city && this.selectCars) {
        let carTypes = []
        this.selectCars.forEach(function (_rowId) {
          let searchCarType
          vm.$root.carTypes.forEach(function (_row) {
            if (_row.id === _rowId) {
              searchCarType = _row
            }
          })
          carTypes.push({
            id: searchCarType.id,
            typeId: _rowId,
            title: searchCarType.title,
            amount: 1
          })
        })

        // 將車輛型態放入清單
        this.$root.register.carTypes = carTypes
        // 前往填入車輛數量
        this.$root.goPage('/reserve-select-people')
      }
    }
  },
};
</script>
<style lang="sass" scoped>
.reserve-page
  padding: 48px 5vmin
  height: 100%
  overflow: auto
  .main-title
    .person
      display: flex
      justify-content: space-between
      align-items: center
      .person-fullName
        font-size: 32px
        font-weight: 700
        line-height: 2ex
        color: #fff
      .person-avatar
        width: 50px
        img
          width: 100%
          vertical-align: middle
    p
      font-size: 24px
      font-weight: 400
      color: #fff
      // padding-top: 13px
  .sub-title
    font-size: 18px
    font-weight: 700
    color: #898A8D
    padding-top: 34px
  .city-select
    width: 100%
    background: #000
    border: 1px solid #22F48F
    color: #22F48F
    height: 80px
    padding: 26px 21px
    margin-top: 13px
    font-size: 4.4vmin
  .rental-type
    margin-top: 20px
    display: flex
    flex-wrap: wrap
    gap: 10px
    margin-bottom: 1vh
    .rental-item
      width: calc((100% - 10px) / 2)
      font-size: 18px
      font-weight: 400
      color: #000
      padding: 14px 10px
      border-radius: 10px
      background-color: #1E1E1E
      border: 3px solid #1E1E1E
      border-radius: 10px
      position: relative
      display: flex
      align-items: center
      gap: 4px
      .rental-item-img
        height: 100%
        max-width: 66px
        max-height: 64px
        margin: 0
      .rental-content
        color: #fff
        font-size: 3.8vmin
        font-weight: 500
        line-height: 6.5vmin
        padding-right: 10px
      &.active
        border: 3px solid #22F48F
    .on-select
      width: 35px
      height: 35px
      border-radius: 5px 0 10px 0
      background: #22F48F
      position: absolute
      right: -3px
      bottom: -3px
      display: flex
      align-items: center
      img
        width: 15px  
      
  .button-group
    padding-top: 15%
    display: flex
    .stepUp
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #fff
      border: none
      padding: 3vmin 0px
    .stepNext
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #898A8D
      border: none
      padding: 3vmin 0px
      &.active
        background-color: #22F48F
    .step-txt
      text-align: center
      font-size: 6vmin
      font-weight: 700
      color: #1E1E1E
</style>
